import { configureErrorHandler } from '@core/error-reporting/ErrorHandler';
import consoleErrorReporter from '@core/error-reporting/reporters/console';
import * as Env from '@members/env';

const isProdEnv = Env.isProdEnv();
export const setupErrorHandler = (env: any) =>
  configureErrorHandler([...(isProdEnv ? [] : [consoleErrorReporter])], {
    environment: env.error,
    release: process.env.COMMIT_REF ?? '',
  });
